import React from 'react';
import PropTypes from 'prop-types';
import PieChart from './PieChart';
import ReportBox from './ReportBox';
import PieChartLegend from './PieChartLegend';
import TotalSalesAmount from './TotalSalesAmount';

const PieChartWithLegend = ({ data, total, title, tooltipText, automationId }) => (
  <ReportBox
    className="c-report-box--has-tooltip"
    title={title}
    tooltipText={tooltipText}
    automationId={`container:${automationId}`}
  >
    <div className="c-chart-grid">
      <PieChart data={data} />
      <div className="c-chart-legend">
        <PieChartLegend data={data} automationId={automationId} />
        <TotalSalesAmount total={total} automationId={`text:${automationId}:totalAmount`} />
      </div>
    </div>
  </ReportBox>
);

PieChartWithLegend.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  total: PropTypes.number,
  title: PropTypes.string,
  tooltipText: PropTypes.string,
  automationId: PropTypes.string,
};

PieChartWithLegend.defaultProps = {
  data: [],
  total: 0,
  title: '',
  tooltipText: '',
  automationId: null,
};

export default PieChartWithLegend;
